import { render } from "./ResourceItem.vue?vue&type=template&id=54030f40&scoped=true&ts=true"
import script from "./ResourceItem.vue?vue&type=script&lang=ts"
export * from "./ResourceItem.vue?vue&type=script&lang=ts"

import "./ResourceItem.vue?vue&type=style&index=0&id=54030f40&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54030f40"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
